import type { ColumnWithFilter } from "../../Components/FilterBar/FilterBar";
import type { LookupTableOption } from "../../Components/DataEntry/Select/LookupTableSelect";
import { getLookupTableText } from "./helpers";

export const buildTruckVendorLookupOption = (truckVendor: any) => ({
  ...truckVendor,
  label: truckVendor?.shortName ?? truckVendor?.name,
  value: truckVendor?._id,
  vehicleList: truckVendor?.vehicleList || [],
  raw: truckVendor,
});

const truckVendorTableColumns: ColumnWithFilter<LookupTableOption>[] = [
  {
    title: "Mã nhà xe",
    dataIndex: "code",
    filterDataIndex: "searchText",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập mã nhà xe",
      },
    },
    width: 130,
    render: (_value, record) => getLookupTableText(record, "code"),
  },
  {
    title: "Tên nhà xe",
    dataIndex: "name",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập tên nhà xe",
      },
    },
    width: 220,
    render: (_value, record) => getLookupTableText(record, "name"),
  },
  {
    title: "Tên viết tắt",
    dataIndex: "shortName",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập tên viết tắt",
      },
    },
    width: 160,
    render: (_value, record) => getLookupTableText(record, "shortName"),
  },
  // {
  //   title: "Địa chỉ",
  //   dataIndex: "address",
  //   width: 240,
  //   render: (_value, record) => getLookupTableText(record, "address"),
  // },
  {
    title: "SĐT",
    dataIndex: "phoneNumber",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập số điện thoại",
      },
    },
    width: 140,
    render: (_value, record) => getLookupTableText(record, "phoneNumber"),
  },
  // {
  //   title: "Hotline",
  //   dataIndex: "hotline",
  //   width: 140,
  //   render: (_value, record) => getLookupTableText(record, "hotline"),
  // },
  // {
  //   title: "MST",
  //   dataIndex: "taxNumber",
  //   width: 140,
  //   render: (_value, record) => getLookupTableText(record, "taxNumber"),
  // },
  {
    title: "Số lượng xe",
    dataIndex: "vehicleList",
    width: 120,
    render: (_value, record) => {
      const vehicleList = record.vehicleList ?? record.raw?.vehicleList;
      return Array.isArray(vehicleList) ? vehicleList.length : 0;
    },
  },
  {
    title: "Tình trạng",
    dataIndex: "state",
    filterConfig: {
      type: "select",
      filterProps: {
        placeholder: "Chọn tình trạng",
        options: [
          { label: "Đang hoạt động", value: "ACTIVE" },
          { label: "Ngưng hoạt động", value: "INACTIVE" },
        ],
      },
    },
    width: 140,
    render: (_value, record) => {
      const state = getLookupTableText(record, "state");
      if (state === "ACTIVE") return "Đang hoạt động";
      if (state === "CLOSED") return "Ngừng hoạt động";
      return state;
    },
  },
];

export const truckVendorLookupTable = {
  popupWidth: 1180,
  searchPlaceholder: "Tìm theo tên nhà xe",
  tableColumns: truckVendorTableColumns,
};
